import axios from "../../utils/axios";

async function addProduct(data) {
  return await axios.post(`/single/products`, data);
}

async function getProducts(params) {
  return await axios.get(`/single/products`, {
    params,
  });
}
async function updateProduct(data, id) {
  return await axios.patch(`/single/products/${id}`, data);
}
async function deleteProduct(id) {
  return await axios.delete(`/single/products/${id}`);
}

async function getProductById(id) {
  return await axios.get(`/single/products/${id}`);
}

async function updateProductPosition(id, data) {
  return await axios.patch(`/single/products/${id}/position`, data);
}
//
async function updateProductDeliveryStatusActivate(id) {
  return await axios.patch(`/single/products/${id}/delivery/activate`);
}

async function updateProducDeliveryStatusDeActivate(id) {
  return await axios.patch(`/single/products/${id}/delivery/deactivate`);
}
async function updateProductPickupStatusActivate(id) {
  return await axios.patch(`/single/products/${id}/pickup/activate`);
}
async function updateProductPickupStatusDeActivate(id) {
  return await axios.patch(`/single/products/${id}/pickup/deactivate`);
}

async function clearBulkUploadDocument(shopId) {
  return await axios.delete(`/single/products/${shopId}/bulk-upload`);
}

async function bulkUploadProducts(shopId, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("shop_id", shopId);
  return await axios.post(`/single/products/bulk-upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const Product = {
  addProduct,
  updateProduct,
  deleteProduct,
  getProducts,
  getProductById,
  updateProductPosition,
  updateProductDeliveryStatusActivate,
  updateProducDeliveryStatusDeActivate,
  updateProductPickupStatusActivate,
  updateProductPickupStatusDeActivate,
  clearBulkUploadDocument,
  bulkUploadProducts,
};
